<template>
  <div class="items">
    <ul class="items__container">
      <li
        v-if="isLoggedRef"
        class="items__container__item items__container__item--logged"
      >
        <span class="items__container__item__text">{{ userDataRef?.fullName }}</span>
        <Button
          icon="pi pi-sign-out"
          severity="danger"
          aria-label="Desconectar"
          class="items__container__item__icon"
          tabindex="0"
          @click="logout"
          @keyup.enter="logout"
        />
      </li>
      <li
        v-for="item in props$$.items"
        :key="item"
        class="items__container__item"
        @click="onClickItem(item)"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import {
  inject,
  onMounted,
  shallowRef,
} from 'vue';

// #region STTEDRA
import {
  useDev,
} from '@sttedra_ui/framework';
// #endregion

import {useRouter} from 'vue-router';

import useComposeUser from '@/composables/compose-user';

import Button from 'primevue/button/sfc';

// #region Props, Emits
const emit = defineEmits(['collapse']);

const props$$ = defineProps({
  items: {
    type: Array,
    default: () => [{
      name: 'Inicio',
      route: 'Home',
    }],
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const router = useRouter();

const appState$$ = inject('appState$$');

const {composeUser} = useComposeUser();

const userDataRef = shallowRef(null);
const isLoggedRef = shallowRef(false);
// #endregion

// #region Functions
function onClickItem(item) {
  const dataRoute = {};

  router.push({
    name: item.route || 'Home',
    ...dataRoute,
  });

  emit('collapse', true);
}

function logout() {
  try {
    appState$$.defaultStateApp();
    goToHome();
    emit('collapse', true);
  } catch (e) {
    useDev.error('[FloatMenuItems.vue] logout', e);
  }
}

function goToHome() {
  try {
    const dataRoute = {};
    router.push({
      name: `Home`,
      ...dataRoute,
    });
  } catch (e) {
    useDev.error('[FloatMenuItems.vue] goToHome', e);
  }
}
// #endregion

// #region Effects, Hooks
onMounted(async () => {
  const isLogged = appState$$.isLogged;
  const token = appState$$.token;

  userDataRef.value = composeUser({
    isLogged,
    token,
  });

  isLoggedRef.value = isLogged;
});
// #endregion

// #region Provide, Expose
// ...
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.items{
  -webkit-box-flex: 5;
      -ms-flex: 5;
          flex: 5;
  &__container{
    color: $pv__color--white;
    height: 100%;
    margin: 0;
    overflow: auto;
    padding: 0;
    &__item{
      cursor: pointer;
      font-size: $pv__fs--xlarge;
      font-weight: 400;
      padding: 1.5rem;
      outline: 1px solid $pv__color--white;


      &__icon{
        height: $pv__dm__icon--xlargue;
        width: $pv__dm__icon--xlargue;
      }

      &__text{
        font-size: $pv__fs--medium;
        margin-right: $brand__boxspace--small;
      }
    }
    &__item:not(.items__container__item--logged):hover{
      background-color: #d9d9d9;
      color: $pv__color--darkblue;
    }

    &__item--logged{

      -webkit-box-align: center;

          -ms-flex-align: center;

              align-items: center;
      background-color: $pv__color--black;
      color: $pv__color--white;
      cursor: unset !important;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      font-size: $pv__fs--xlarge;
      font-weight: 400;
      -webkit-box-pack: space-evenly;
          -ms-flex-pack: space-evenly;
              justify-content: space-evenly;
      padding: 1.5rem;
    }
  }
}
</style>
